import React, { useEffect, useState } from 'react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { Box, Flex } from '@chakra-ui/react';

import { checkPulse } from '../api';
import themeStyles from '../theme/styles';
import { isEmpty } from '../utils/core';
import Text from './Text';

const { textStyles: themeTextStyles } = themeStyles;

export const reloadSlow = process.env.REACT_APP_RELOAD_SLOW_MS || '60000';
export const reloadFast = process.env.REACT_APP_RELOAD_FAST_MS || '15000';
const slow = parseInt(reloadSlow, 10);
const fast = parseInt(reloadFast, 10);

const VersionInfo = ({ textStyle = 'footer', styles, as, ...props }) => {
  const [apiState, setApiState] = useState({ status: 'loading' });
  const [reloadRate, setReloadRate] = useState(slow + 500);

  const pulseReading = async () => {
    try {
      // heartbeat provides API metadata
      const response = await checkPulse();
      if (isEmpty(response)) {
        throw new Error('Empty API status response received');
      }
      setApiState(response);
      // back online? slow back down again
      if (reloadRate === fast) {
        setReloadRate(slow);
      }
    } catch (e) {
      console.warn('Failed to check API state', e);
      const { message } = e;
      setApiState({ ...apiState, status: 'error', error: message });
      // keep a closer eye on the API
      setReloadRate(fast);
    }
  };

  useEffect(() => {
    pulseReading();
    // poll heartbeat/status
    const poller = setInterval(pulseReading, reloadRate);
    return () => clearInterval(poller);
  }, [reloadRate]);

  const style = {
    ...themeTextStyles[textStyle],
    ...styles,
  };

  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      style={style}
      {...props}
      title={`Status: ${apiState.status}${apiState.error ? `, error: ${apiState.error}` : ''}`}
    >
      {`${apiState.status}`.toLowerCase() === 'ok' ? (
        <Box
          w={3}
          h={3}
          bgColor="#74B65F"
          borderRadius="50%"
          mr="0.5em"
        />
      ) : (
        <WarningTwoIcon w={4} h={4} mr="0.5em" color="#ED8812" />
      )}
      <Text as={as} mr="0.5em">Palm Bridge Tracker</Text>
      {apiState.version && (
        <Text as={as} mr="0.5em">{`v${apiState.version}`}</Text>
      )}
      {apiState.revision && (
        <Text as={as} style={themeTextStyles.small}>{`(${apiState.revision})`}</Text>
      )}
    </Flex>
  );
};

export default VersionInfo;
